import { render } from "./gelf.vue?vue&type=template&id=7a480f7c"
import script from "./gelf.vue?vue&type=script&lang=js"
export * from "./gelf.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__